import { render } from "./ProfileEvents.vue?vue&type=template&id=2dd066c0"
import script from "./ProfileEvents.vue?vue&type=script&lang=js"
export * from "./ProfileEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__